import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getUserConversations, saveConversation, deleteConversation } from '../services/apiService';

export const fetchUserConversations = createAsyncThunk(
  'conversations/fetchUserConversations',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getUserConversations();
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const saveUserConversation = createAsyncThunk(
  'conversations/saveUserConversation',
  async (conversationData, { rejectWithValue }) => {
    try {
      const response = await saveConversation(conversationData);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const removeConversation = createAsyncThunk(
  'conversations/removeConversation',
  async (conversationId, { rejectWithValue }) => {
    try {
      await deleteConversation(conversationId);
      return conversationId;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const conversationsSlice = createSlice({
  name: 'conversations',
  initialState: {
    conversations: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserConversations.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserConversations.fulfilled, (state, action) => {
        state.loading = false;
        state.conversations = action.payload;
      })
      .addCase(fetchUserConversations.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(saveUserConversation.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(saveUserConversation.fulfilled, (state, action) => {
        state.loading = false;
        state.conversations.push(action.payload);
      })
      .addCase(saveUserConversation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(removeConversation.fulfilled, (state, action) => {
        state.loading = false;
        state.conversations = state.conversations.filter(
          (conversation) => conversation.id !== action.payload
        );
      })
      .addCase(removeConversation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default conversationsSlice.reducer;




